module.exports = __webpack_public_path__ + "media/bootstrap-icons/textarea-t-917c387e.svg";